<template>
    <div>
        <h3>プロットと執筆実績</h3>
        <div>
            <p class="text-danger">
                プロットと執筆実績はβ機能です。大幅に仕様変更されたり、削除されることがあります。
            </p>
            <p>
                プロットを作成することで、事前に小説全体のエピソード設計が可能になります。
            </p>
            <p>
                プロットはタイトルとあらすじだけのエピソードを追加する機能で、本文は空の状態になります。
                プロット画面は本文一覧と同等に、章の追加、エピソードの順番変更が可能です。
                これらのエピソードには１４０文字以内のあらすじを記述することができます。
            </p>
            <p>
                このあらすじはノートに記載することのできる全体の梗概とことなり、そのエピソードに執筆する予定の概要です。
                プロットを最終話まで作成しておくことで、執筆の進捗を可視化します。
            </p>
            <h4>プロットの作成</h4>
            <p>
                本文一覧のサイドメニュー「プロット」からプロット作成画面を開きます。
                「本文追加」ボタンで、エピソードタイトルとプロットを記述してください。
                プロットは改行できず、１４０文字を超えたものは（保存はできますが）表示されません。
            </p>
            <p>
                プロットは本文執筆中はサイドバーのノートパネルに表示されます。
                ノートパネルのプロットを直接編集することもできます。
            </p>
            <h4>執筆実績</h4>
            <p>
                プロット画面か執筆画面のサイドバーに、執筆実績パネルが表示されます。
                執筆中であれば、リアルタイムに実績は更新されていきます。
            </p>
            <p>
                執筆実績がしきい値に達しない場合、小説情報を基準に数値算出されます。
                しきい値を超えた場合は、記録された執筆実績データを元に数値が算出されます。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "プロットと実績 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>